import { render } from "./NutonExperiment.vue?vue&type=template&id=47622bff&scoped=true"
import script from "./NutonExperiment.vue?vue&type=script&lang=js"
export * from "./NutonExperiment.vue?vue&type=script&lang=js"

import "./NutonExperiment.vue?vue&type=style&index=0&id=47622bff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47622bff"]])

export default __exports__